export default {
  commons: {
    warning: 'Attenzione',
    compileAllFields: 'Devi compilare tutti i campi per proseguire',
    ok: 'OK',
    confirm: 'CONFERMA',
    confirmAndContinue: 'CONFERMA E PROCEDI',
    goBack: 'INDIETRO',
    yes: 'Sì',
    no: 'No',
    error: 'ERRORE',
    connectionError: 'Problema di connessione internet. Se sei da una rete mobile verifica di avere campo.',
    add: 'Aggiungi',
    save: 'Salva',
    edit: 'Modifica',
    dataSaved: 'Dati salvati',
    cancel: 'Annulla',
  },
  auth: {
    intro: 'Digita le tue credenziali per effettuare l\'accesso al sistema.',
    dashboard: 'DASHBOARD AMMINISTRATIVA',
    changeLanguage: 'Vuoi cambiare la lingua?',
    email: 'Email',
    password: 'Password',
    repeatPassword: 'Ripeti la password',
    repeatPasswordError: 'Le password non coincidono',
    invalidEmail: 'Email non valida',
    login: 'Accedi',
    registerInfo: 'Compila i seguenti dati per registrarti',
    register: 'Registrati',
    passwordLost: 'Password dimenticata?',
    registerQuestion: 'Non sei ancora iscritto? Registrati!',
    loginQuestion: 'Sei già iscritto? Collegati!',
    loading: 'Operazione in corso...',
    wrongCredentialsTitle: 'Errore di accesso',
    wrongCredentials: 'Nome utente o password errati',
    emailAlreadyExists: 'Email già registrata',
    mustActivateTitle: 'Account non attivo',
    mustActivate: 'Il tuo account non è attivo.',
    recoverPassword: 'Recupera password',
    recoverPasswordInfo: 'Inserisci la tua email per recuperare la password',
    emailSentCheckInbox: 'Email inviata: verifica la tua casella di posta',
    setNewPassword: 'Imposta una nuova password',
    passwordChanged: 'Password modificata. Ora puoi accedere con la tua nuova password',
    twoFactorTitle: 'Autenticazione a due fattori',
    twoFactorDescription: 'Ti è stato inviato un codice di verifica all\'indirizzo email. Inseriscilo qui sotto per completare l\'accesso.',
    twoFactorCode: 'Inserisci il codice',
  },
  profileSettings: {
    changePassword: {
      title: 'Cambia password',
      insertOldPassword: 'Inserisci la password attuale',
      insertNewPassword: 'Inserisci la nuova password',
      repeatNewPassword: 'Ripeti la nuova password',
      passwordChanged: 'Password modificata',
      oldPasswordWrong: 'La password attuale non è corretta',
      minimumPasswordLength: 'La password deve essere lunga almeno 10 caratteri',
    },
  },
  mediaSources: {
    removeTitle: 'Rimuovi sorgente media',
    removeMessage: 'Sei sicuro di voler rimuovere la sorgente media?',
    removeConfirm: 'Rimuovi',
  }
};
